
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon i-light-bulb",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","stroke":"currentColor","fill":"transparent","class":"icon i-light-bulb"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"i-light-bulb__globe",attrs:{"d":"M13.52 6.56A4.68 4.68 0 009 1.74a4.68 4.68 0 00-4.52 4.82c0 2.62 1.79 4.35 2.13 5.81h4.78c.34-1.46 2.13-3.19 2.13-5.81z"}}),_c('path',{staticClass:"i-light-bulb__stem",attrs:{"d":"M6.78 13.59l.01.88 1.32 1.79h1.78l1.34-1.79v-.88"}}),_c('path',{staticClass:"i-light-bulb__filament",attrs:{"d":"M9.01 7.48v3.51"}})])
          )
        }
      }
    